// FILE: quizmaster/app/src/firebase/config.js
// DESC: A dedicated file for our Firebase configuration to keep things clean.

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Replace with your project's Firebase configuration from your Firebase console.
const firebaseConfig = {
  apiKey: "AIzaSyA4QPZ10DFwZkPLNvSX8bUN869momFmJnI",
  authDomain: "quizmaster-5fd10.firebaseapp.com",
  projectId: "quizmaster-5fd10",
  storageBucket: "quizmaster-5fd10.firebasestorage.app",
  messagingSenderId: "831390249083",
  appId: "1:831390249083:web:5f4e8afba168f90a2b72de",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firebase services for use in other parts of the app
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
